import noUiSlider from 'nouislider';
import CityPicker from '../zipCityPicker.js';
import { createApp } from 'vue';

let memberTriggers = document.querySelectorAll('[data-show-member-id]');

let addTriggerClick = (trigger) => {
    return (e) => {
        e.preventDefault();
        let id = trigger.getAttribute('data-show-member-id');
        let memberData = document.querySelector('[data-member-data="'+id+'"]');
        if (memberData) {
            let prevSelected = document.querySelector('.mypage__member--active');
            if (prevSelected) {
                prevSelected.classList.remove('mypage__member--active');
            }
            memberData.classList.add('mypage__member--active');
        }
        let prevTrigger = document.querySelector('.family-member--active');
        if (prevTrigger) {
            prevTrigger.classList.remove('family-member--active');
        }
        trigger.classList.add('family-member--active');
    }
};

for (let i=0; i<memberTriggers.length; i++) {
    let trigger = memberTriggers[i];
    trigger.addEventListener('click', addTriggerClick(trigger));
}

let tabSections = document.querySelectorAll('.mypage__member');

let showTab = (target, section) => {
    let tab = document.querySelector('[data-tab-target="'+target+'"]');
    if (tab) {
        let prevSelected = section.querySelector('.mypage__member-content--active');
        if (prevSelected) {
            prevSelected.classList.remove('mypage__member-content--active');
        }
        tab.classList.add('mypage__member-content--active');
    }

   let prevTrigger = section.querySelector('.mypage__member-tab--active');
   if (prevTrigger) {
       prevTrigger.classList.remove('mypage__member-tab--active');
   }
   let trigger = document.querySelector('[data-member-tab="'+target+'"]')
   trigger.classList.add('mypage__member-tab--active');
};


let addTabClick = (trigger, section) => {
    return (e) => {
        e.preventDefault();
        let target = trigger.getAttribute('data-member-tab');
        showTab(target, section);
    }
};

for (let i=0; i<tabSections.length; i++) {
    let section = tabSections[i];
    let tabs = section.querySelectorAll('.mypage__member-tab');
    for (let j=0; j<tabs.length; j++) {
        let tab = tabs[j];
        tab.addEventListener('click', addTabClick(tab, section));
    }
}

let initSlider = (slider) => {
    let targetId = slider.getAttribute('data-target');
    let target = document.getElementById(targetId);
    let min = parseInt(slider.getAttribute('data-min'));
    let max = parseInt(slider.getAttribute('data-max'));
    let step = parseInt(slider.getAttribute('data-step'));

    if (step != '1') {
        min = step;
    }

    noUiSlider.create(slider, {
        start: parseInt(target.value),
        connect: [true, false],
        step: step,
        range: {
            'min': min,
            'max': max
        }
    });

    slider.noUiSlider.on('update', function(values, handle) {
        let value = values[handle];
        target.value = Math.round(value);
    });

    target.addEventListener('keypress', (e) => {
        // Handle paste
        if (e.type === 'paste') {
            key = event.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = e.keyCode || e.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\./;
        if( !regex.test(key) ) {
            e.returnValue = false;
            e.preventDefault();
        }
    });
    target.addEventListener('change', function() {
        let value = this.value;
        if (value > max) {
            max = parseInt(value);
            slider.noUiSlider.updateOptions({
                range: {
                    'min': min,
                    'max': max
                }
            });
        }
        slider.noUiSlider.set([value, null]);
        slider.noUiSlider.updateOptions({
            step: step
        });
    });
}

let sliders = document.querySelectorAll('.st-slider');

for (let i=0; i<sliders.length; i++) {
    initSlider(sliders[i]);
}

let hideModal = (e) => {
    e.preventDefault();
    modalBk.classList.remove('st-modal__bk--active');
    let activeModals = document.querySelectorAll('.st-modal--active');
    for (let i=0; i<activeModals.length; i++) {
        activeModals[i].classList.remove('st-modal--active');
    }
};

let setupModal = (link) => {
    let targetId = link.getAttribute('data-showmodal');
    let target = document.getElementById(targetId);
    link.addEventListener('click', (e) => {
        e.preventDefault();
        target.classList.add('st-modal--active');
        modalBk.classList.add('st-modal__bk--active');
    });
}

let modalLinks = document.querySelectorAll('.mypage__edit');
let modalBk = document.querySelector('.st-modal__bk');

for (let i=0; i<modalLinks.length; i++) {
    setupModal(modalLinks[i]);
}

let modalHiders = document.querySelectorAll('.st-modal__close');

for (let i=0; i<modalHiders.length; i++) {
    modalHiders[i].addEventListener('click', hideModal);
}

if (location.hash == '#members' && tabSections.length) {
    let section = tabSections[0];
    let tabs = section.querySelectorAll('.mypage__member-tab');
    if (tabs.length) {
        let trigger = tabs[1];
        let target = trigger.getAttribute('data-member-tab');
        showTab(target, section);
    }
}

const postAddressPickerElement = document.querySelector('[data-post-address-finder]');
if(postAddressPickerElement) {
    const postAddressPicker = createApp(CityPicker).mount(postAddressPickerElement);
}